import { render, staticRenderFns } from "./LiveSupplierAttendeeFAQ.vue?vue&type=template&id=29a9a8d9&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports